import React, { useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';

import GetCustomerContact, {
  CustomerContact,
} from "../utils/GetCustomerContact";
import { useParams } from "react-router-dom";
import { TextFieldData } from "../componentUtils/TextFields";
import { useLocalStorage } from "../componentUtils/LocalStorage";

interface CustomerRouteParams {
  identifier: string;
}

interface CustomerContactState {
  isLoaded: boolean;
  contacts: CustomerContact[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
    },
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      paddingTop: theme.spacing(1),
    },
    mapContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  })
);

export default function CustomerContacts() {
  const routeParams = useParams<CustomerRouteParams>();
  const classes = useStyles();
  const [state, setState] = React.useState<CustomerContactState>({
    isLoaded: false,
    contacts: [],
  });
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const disabledTextFields: TextFieldData[] = [
    {
      title: "First Name",
      field: "first_name",
      md: 6,
      lg: 3,
    },
    {
      title: "Last Name",
      field: "last_name",
      md: 6,
      lg: 3,
    },
    {
      title: "Email Address",
      field: "email",
      md: 6,
      lg: 3,
    },
    {
      title: "Phone",
      field: "phone",
      md: 6,
      lg: 3,
    },
  ];

  useEffect(() => {
    GetCustomerContact(salesOrg.toString(), routeParams.identifier).then(
      (v: CustomerContact[]) => {
        let out:any={
          "first_name":null,
          "last_name":null,
           "email": null,
           "phone": null,
        }
        let p_function_18 = v.filter((i:any)=>i.pFunction=='18')
        let p_function_ZQ = v.filter((i:any)=>i.pFunction=='18')
            //console.log("p_function_18",p_function_18[0].firstName);

        if(p_function_18[0].firstName){
          out.first_name = p_function_18[0].firstName;
        }else{
          out.first_name = p_function_ZQ[0].firstName;
        }
        if(p_function_18[0].lastName){
          out.last_name = p_function_18[0].lastName;
        }else{
          out.last_name = p_function_ZQ[0].lastName;
        }
        if(p_function_18[0].email){
          out.email = p_function_18[0].email;
        }else{
          out.email = p_function_ZQ[0].email;
        }
        if(p_function_18[0].phone){
          out.phone = p_function_18[0].phone;
        }else{
          out.phone = p_function_ZQ[0].phone;
        }


        setState({
          ...v,
          isLoaded: true,
          contacts:[{...out}] 
        });
      }
    );
  }, [state.isLoaded, routeParams.identifier, salesOrg]);

  if (!state.isLoaded || state.contacts.length < 1) return <div />;

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.gridMarginTop}>
        Contacts ({state.contacts.length})
      </Typography>
      {state.contacts.map((c: CustomerContact, i:number) => (
        <Grid container spacing={2} className={classes.gridMarginTop} key={`CustomerContact-${i}-grd`}>
          {disabledTextFields.map((v: TextFieldData, i2:number) => {
            let q = c[v.field];
            return (
              <Grid item lg={v.lg} xs={v.md} className={classes.gridSpaceable} key={`CustomerContact-${i}-${i2}-grd`}>
                <TextField
                  fullWidth={true}
                  key={`CustomerContact-${i}=${i2}`}
                  label={v.title}
                  value={q}
                  defaultValue={q}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      ))}
    </div>
  );
}
